import React, { useState, useRef } from "react";
import {
  SFDrawer,
  SFGridContainer,
  SFGridItem,
  SFButton,
  SFDataGrid,
  SFIcons,
} from "@sf-core";
import { useTranslation } from "react-i18next";
import DrawerAccordion from "./components/drawerAccordion";
import CustomNameCell from "./components/customNameCell";
import CustomGroupCell from "./components/customGroupCell";
import CustomRadioCell from "./components/customRadioCell";

// Footer of Drawer to save the selected grid items or cancel the drawer
const FooterDrawer = ({ onClose, onSave, isSkillDrawer, selectedItems }) => {
  const { t } = useTranslation();
  const addButton = isSkillDrawer
    ? t("profileScreen.drawer.skillSelection.btnAddSkills")
    : t("profileScreen.drawer.jobSelection.btnAddJobs");

  return (
    <SFGridContainer spacing={1.5}>
      <SFGridItem>
        <SFButton variant="transparent" onClick={onClose}>
          {t("profileScreen.btnCancel")}
        </SFButton>
      </SFGridItem>
      {selectedItems?.length > 0 && (
        <SFGridItem>
          <SFButton  startIcon={<SFIcons.SFCheckIcon />} variant="secondary" onClick={onSave}>
            {addButton}
          </SFButton>
        </SFGridItem>
      )}
    </SFGridContainer>
  );
};

const StepDrawer = ({
  open,
  onClose,
  onSave,
  isSkillDrawer,
  header,
  columnDefs,
  gridName,
  searchLabel,
  filterLabel,
  datasourceUrl,
  filterValuesUrl,
  initialGridState,
}) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const gridRef = useRef(null);

  // Save the selected items and close the drawer
  const handleSave = () => {
    onSave(selectedItems);
    setSelectedItems([]);
    onClose();
  };

  const groupRowRenderer = "CustomGroupCell";
  const customComponents = {
    CustomNameCell,
    CustomGroupCell,
    CustomRadioCell: (params) => (
      <CustomRadioCell
        {...params}
        onClick={(data) => {
          setSelectedItems((prevItems) => [...prevItems, data]);
        }}
      />
    ),
  };

  return (
    <SFDrawer
      open={open}
      size={"l"}
      onClose={onClose}
      header={header}
      footer={
        <FooterDrawer
          onClose={onClose}
          onSave={handleSave}
          isSkillDrawer={isSkillDrawer}
          selectedItems={selectedItems}
        />
      }
      disableGutters
      disablePadding
    >
      <>
        <SFDataGrid
          gridName={gridName}
          searchLabel={searchLabel}
          filterLabel={filterLabel}
          ref={gridRef}
          disableFilterSideBar
          columnDefs={columnDefs}
          persistState={true}
          hasRowSelection
          {...(initialGridState && {
            initialGridState: initialGridState,
          })}
          customComponents={customComponents}
          datasourceUrl={datasourceUrl}
          filterValuesUrl={filterValuesUrl}
          noCardBorder
          groupRowRenderer={groupRowRenderer}
          suppressHorizontalScroll={true}
          suppressGroupRowsSticky={true}
          hideHeader
          subBar={
            <DrawerAccordion
              accordionOpen={true}
              selectedItems={selectedItems}
              setSelectedItems={setSelectedItems}
              isSkillDrawer={isSkillDrawer}
              gridRef={gridRef}
            />
          }
        />
      </>
    </SFDrawer>
  );
};

export default StepDrawer;
